import { render, staticRenderFns } from "./NormalItemConfig.vue?vue&type=template&id=33951f06&scoped=true"
import script from "./NormalItemConfig.vue?vue&type=script&lang=js"
export * from "./NormalItemConfig.vue?vue&type=script&lang=js"
import style0 from "./NormalItemConfig.vue?vue&type=style&index=0&id=33951f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33951f06",
  null
  
)

export default component.exports